<template>
  <div>
    <!-- BANNER -->
    <div class="banner">
      <div class="banner-overlay box-overlay rounded-top-10">
        <img v-lazy="localImg(banner)" class="img" />

        <!-- PREFETCH OTHER IMAGES -->
        <img
          v-lazy="localImg('DisplayBanner.png')"
          class="d-none"
          width="0"
          height="0"
        />
        <img
          v-lazy="localImg('TeacherDialog.png')"
          class="d-none"
          width="0"
          height="0"
        />
        <img
          v-lazy="localImg('DialogOne.png')"
          class="d-none"
          width="0"
          height="0"
        />
        <img
          v-lazy="localImg('DialogTwo.png')"
          class="d-none"
          width="0"
          height="0"
        />
        <img
          v-lazy="localImg('DialogThree.png')"
          class="d-none"
          width="0"
          height="0"
        />
        <img
          v-lazy="localImg('DialogFour.png')"
          class="d-none"
          width="0"
          height="0"
        />
        <!-- PREFETCH OTHER IMAGES -->
      </div>
      <!-- BRAND ICON -->
      <img v-lazy="localImg(display_img)" class="brand-icon" />
    </div>

    <!-- WELCOME BLOCK -->
    <div
      class="welcome-block w-100 d-flex flex-column justify-content-start align-items-center"
    >
      <div class="welcome-title font-weight-bold brand_navy">
        Welcome to Gradely
      </div>
      <div class="welcome-text color_grey_dark text-center">
        <template v-if="account_type === 'school' || account_type === 'teacher'"
          >Gradely is the easiest way to develop learning experiences beyond the
          four walls of school</template
        >
        <template v-if="account_type === 'parent'"
          >Gradely lets you monitor and support your child’s journey to academic
          mastery</template
        >
        <template v-if="account_type === 'student'"
          >You are about to unwrap the joy of daily practice, videos and tutors
          adapted just for you</template
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogOne",
  props: ["banner", "display_img"],
  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },
};
</script>

<style>
</style>
